import { useState } from "react";

/** CHANGE_review_responses: one row of answers to one item, shared by the SME card and the QA drawer. A choice is
 *  a toggle (pressing it again clears it); an option with `action` runs straight away instead (Fix it, Ask an SME). */
export interface ResponseOption { id: string; label: string; action?: () => void; disabled?: boolean; title?: string }

export function ResponseRow({ label, options, value, onChange }: { label: string; options: ResponseOption[]; value?: string | null; onChange?: (id: string | null) => void }) {
  return (
    <div className="response-row" role="group" aria-label={label}>
      {options.map((o) => (
        <button key={o.id} type="button" className={`chip-btn ${value === o.id ? "on" : ""}`} aria-pressed={o.action ? undefined : value === o.id} disabled={o.disabled} title={o.title}
          onClick={() => (o.action ? o.action() : onChange?.(value === o.id ? null : o.id))}>{o.label}</button>
      ))}
    </div>
  );
}

/** "+ Add a note": available beside any choice; the note travels with the reply. */
export function NoteField({ about, value, onChange }: { about: string; value: string; onChange: (v: string) => void }) {
  const [open, setOpen] = useState(!!value);
  return open
    ? <textarea className="note-field" rows={2} value={value} onChange={(e) => onChange(e.target.value)} placeholder="Your note" aria-label={`Note on: ${about}`} autoFocus={!value} />
    : <button type="button" className="link small" onClick={() => setOpen(true)}>+ Add a note</button>;
}
